// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
    0% { right: -101%; }
    100% { right: 5%;  }
`

const Wrapper = styled.div`
    color: ${({theme}) => theme.mobile.contrast};
    position: absolute;
    top: 2%;
    right: 2%;
    animation: ${slideIn};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
`

const MobileTitle = ({ ...props }) => {

    const getTitle = () => {
        switch (window.location.pathname) {
            case '/washes':
                return 'Washes';
            case '/plans':
                return 'Clubs';
            case '/account':
                return 'Account';
            case '/referral':
                return 'Referral';
            case '/deals':
                return 'Deals';
            case '/findUs':
                return 'Find Us';
            case '/airPay':
                return 'AirPAY';
            default:
                return null;
        }
    }

    const title = getTitle();

    if (!title) return null;

    return <Wrapper>{title}</Wrapper>;
}

export default MobileTitle;